
import { defineComponent } from 'vue';
import { adService } from '../AdService';

import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
  Plugin
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale
)

export default defineComponent({
  name: 'AdViewsStatistics',
  props: {
    ad: {
      type: Object,
      required: true,
    },
    chartId: {
      type: String,
      default: 'line-chart'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
  },
  components: {
    Line
  },
   data() {
    return {
      isLoading: false,
      data: null as any,
      chartData: null,
      chartOptions: null,
      type: 1
    };
  },
  async created() {
      await this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        const params = {} as any;
        params.type = this.type;
        this.data = (await adService.getViewsStatistics(this.ad.adId, params)).data;
        this.initChart(this.data);
        this.isLoading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async selectType(type: number)
    {
      this.type = type;
      await this.loadData();
    },
    initChart(data)
    {
      const mainColor = '#17ce73';

      this.chartData = {
        labels: data.labels ?? [],
        datasets: [
          {
            label: this.$t('AdViewsStatistics.chart-tooltip-label'),
            backgroundColor: mainColor,
            borderColor: mainColor,
            borderWidth: 1,
            pointRadius: 5,
            pointHoverRadius: 10,
            data: data.items ?? []
          }
        ]
      }

      this.chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              display: false
            }
          }, 
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0
            }
          }
        },  
        plugins: {
          legend: {
              display: false,
          },           
          tooltip: {
            displayColors: false,
            backgroundColor: '#fff',
            borderColor: '#666',
            borderWidth: 1,
            titleColor: '#666',
            titleFont: {weight: 'normal'},
            titleAlign: 'center',
            bodyColor: '#666',
            bodyAlign: 'center',
            yAlign: 'bottom',
            callbacks: {
                labelTextColor: function(tooltipItem, chart) {
                    return mainColor;
                }
            }
          },
        }
      }
    },
  }
});
